// client/src/data/history_data.js
// ARTIIK YEREL DOSYA KULLANILMIYOR
// Veriler sunucu tarafindan (SSR benzeri) index.html icine window.historyData olarak enjekte ediliyor.

const historyData = window.historyData || {
    "default": {
        year: 2024,
        title: "GADDAR BİLGİ",
        text: "Veriler yükleniyor...",
        questions: []
    }
};

export default historyData;
